<template>
  <div class="page-main-bg">
    <v-container class="main-container">
      <!--Loader-->
      <loader v-if="isLoading" v-bind="loaderProps" class="mt-2" />

      <template v-else>
        <!--tool-bar-->
        <ToolBar v-bind="toolBarProps" />

        <AccountDetailsButtons class="mb-2" :tab="tab">
          <h3 class="my-auto" v-text="account.name?.ar || ''" />
        </AccountDetailsButtons>

        <v-card class="pa-0 d-flex align-center justify-space-between mb-4">
          <v-tabs
            align-with-title
            color="primary"
            right
            v-model="tab"
            class="setting__page__tabs"
          >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="tab.name"
              class="rounded-15"
              :class="[index === 0 ? 'mr-0' : 'mr-6']"
              :ripple="false"
            >
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <v-menu
            content-class="dropdown-menu mt-8"
            transition="slide-x-transition"
            bottom
            offset-x
          >
            <template #activator="{ on, attrs }">
              <v-btn
                class="ma-0 mt-2 ml-1"
                color="lamb"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="black">mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list>
              <template v-for="action in validActions">
                <v-list-item
                  class="d-flex align-center mb-2"
                  v-if="
                    !action.eligibleStatus ||
                    action.eligibleStatus.includes(account.status)
                  "
                  :key="action.title"
                  @click="handleAction(action.method)"
                >
                  <img
                    v-if="action.img"
                    :src="action.img"
                    class="ml-3 action-img"
                    loading="lazy"
                  />
                  <v-icon v-else class="ml-3" :color="action.iconColor">{{
                    action.icon
                  }}</v-icon>
                  <span :class="action.class">{{ action.title }}</span>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-card>

        <!-- Components -->
        <v-tabs-items :value="tab">
          <v-tab-item>
            <DataTableAccounts
              ref="accountDetails"
              :accounts="[account]"
              :detailsView="true"
              @toggleActivation="toggleActivation"
              @archiveAccount="$router.push({ name: 'accounts' })"
            />
          </v-tab-item>
          <v-tab-item>
            <Transactions :account="account" :ShowAddTransactionBtn="false" />
          </v-tab-item>
          <v-tab-item>
            <AccountActivityLog :account="account" />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-container>

    <!----------------------------->
    <!------ Add client modal ----->
    <!----------------------------->

    <EditAccountModal
      v-if="dialogState"
      :dialogState="dialogState"
      :accountTypes="accountTypes"
      :editedAccount="account"
      @close-account-dialog="setDialogState(false)"
      @refresh-accounts-list="getAccountDetails"
    />
  </div>
</template>

<script>
import ToolBar from '@/components/listing/ToolBar'
import AccountDetailsButtons from '../../components/accounts/details/AccountDetailsButtons.vue'
import DataTableAccounts from '../../components/accounts/DataTableAccounts.vue'
import loader from '@/components/helper/loader.vue'

import { getAccountById } from '@/services/accounts.service'
import { mapMutations, mapState } from 'vuex'
import getAccountTypes from '@/mixins/getAccountTypes'
import accountStaticData from '@/components/accounts/constants'

export default {
  name: 'AccountDetails',
  components: {
    ToolBar,
    AccountDetailsButtons,
    DataTableAccounts,
    loader,
    Transactions: () =>
      import('@/components/accounts/transactions/Transactions.vue'),
    AccountActivityLog: () =>
      import('@/components/accounts/details/AccountActivityLog.vue'),
    AccountAttachments: () =>
      import('@/components/accounts/details/AccountAttachments.vue'),
    EditAccountModal: () =>
      import('../../components/accounts/AddAccountModal.vue')
  },
  mixins: [getAccountTypes],
  data() {
    return {
      ...accountStaticData,
      account: {},
      tab: 0,
      tabs: [
        {
          name: 'تفاصيل الحساب',
          component: 'DataTableAccounts'
        },
        {
          name: 'كشف الحساب',
          component: 'Transactions'
        },
        {
          name: 'سجل النشاطات',
          component: 'AccountActivityLog'
        }
        // {
        //   name: 'المرفقات',
        //   component: 'AccountAttachments'
        // }
      ],
      isLoading: false,
      dialogState: false
    }
  },
  computed: {
    ...mapState('accountState', ['currentEnv']),
    breadcrumbs() {
      return [
        {
          text: 'الحسابات',
          to: {
            path: '/dashboard/accounts'
          }
        },
        { text: this.account.name?.ar, disabled: true }
      ]
    },
    toolBarProps() {
      return {
        breadcrumbs: this.breadcrumbs,
        title: ''
      }
    },
    loaderProps() {
      return {
        numberOfLines: 8,
        laoderClasses: 'my-2 shadow-border-radius pa-0',
        type: 'list-item-avatar-two-line',
        cols: 12
      }
    },
    validActions() {
      return this.actions.filter(
        (action) => action.method !== 'navigateToAccountDetails'
      )
    }
  },
  methods: {
    ...mapMutations('appState', ['addNotification']),
    async getAccountDetails() {
      try {
        this.isLoading = true
        const { data } = await getAccountById(this.$route.params.id)
        this.account = data.data
      } catch {
        this.addNotification({
          text: 'خطاء في تحميل بيانات الحساب',
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    setDialogState(val) {
      this.dialogState = val
    },
    toggleActivation({ isActive }) {
      this.account.status = isActive ? 'inactive' : 'active'
    },
    handleAction(method) {
      if (method === 'editAccount') {
        this.setDialogState(true)
        return
      }
      this.$refs.accountDetails[method](this.account)
    }
  },
  created() {
    this.getAccountDetails()
    this.getTypes(this.currentEnv._id)
  }
}
</script>

<style lang="scss" scoped>
.v-tab {
  font-size: 0.75rem;
}
.theme--light.v-tabs-items {
  background: transparent;
}
</style>
